"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconClass = exports.openNoticeModal = exports.openWarningSuccess = exports.openWarningModal = exports.openErrorModal = exports.openMessageModal = void 0;

var _actions = require("../../skybase-core/base/actions");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var openMessageModal = function openMessageModal(_ref) {
  var dispatch = _ref.dispatch,
      type = _ref.type,
      title = _ref.title,
      message = _ref.message,
      buttons = _ref.buttons;
  dispatch((0, _actions.openModal)(_constants.MESSAGE_MODAL_ID, {
    title: title,
    type: type,
    message: message,
    buttons: buttons
  }));
};

exports.openMessageModal = openMessageModal;

var openErrorModal = function openErrorModal(_ref2) {
  var params = _extends({}, _ref2);

  openMessageModal(_objectSpread(_objectSpread({}, params), {}, {
    type: _constants.modalType.ERROR
  }));
};

exports.openErrorModal = openErrorModal;

var openWarningModal = function openWarningModal(_ref3) {
  var params = _extends({}, _ref3);

  openMessageModal(_objectSpread(_objectSpread({}, params), {}, {
    type: _constants.modalType.WARNING
  }));
};

exports.openWarningModal = openWarningModal;

var openWarningSuccess = function openWarningSuccess(_ref4) {
  var params = _extends({}, _ref4);

  openMessageModal(_objectSpread(_objectSpread({}, params), {}, {
    type: _constants.modalType.SUCCESS
  }));
};

exports.openWarningSuccess = openWarningSuccess;

var openNoticeModal = function openNoticeModal(_ref5) {
  var params = _extends({}, _ref5);

  openMessageModal(_objectSpread(_objectSpread({}, params), {}, {
    type: _constants.modalType.NOTICE
  }));
};

exports.openNoticeModal = openNoticeModal;

var getIconClass = function getIconClass(type) {
  var iconClass;

  switch (type) {
    case _constants.modalType.SUCCESS:
      iconClass = 'sbi-big-success';
      break;

    case _constants.modalType.WARNING:
      iconClass = 'sbi-big-warning';
      break;

    case _constants.modalType.ERROR:
      iconClass = 'sbi-big-error';
      break;

    case _constants.modalType.NOTICE:
      iconClass = 'sbi-big-info';
      break;

    default:
      break;
  }

  return iconClass;
};

exports.getIconClass = getIconClass;
//# sourceMappingURL=utils.js.map